import { i18n } from '@lingui/core'
import { Paper } from '@mui/material'
import { useRouter } from 'next/router'
import { RelatedProductGroups } from '../Amasty/RelatedProductGroups'
import { PrimaryButton } from '../Button'

type RelatedProductsProps = {
  className?: string
  noHorizontalMargins?: boolean
  product_uid?: string
}
export function RelatedProducts(props: RelatedProductsProps) {
  const { className, noHorizontalMargins, product_uid } = props
  const router = useRouter()
  const handleClick = async (href: string) => {
    await router.push(href)
  }

  return (
    <div className='mb-[20px] flex w-full items-center justify-center'>
      <div
        className={`${
          noHorizontalMargins ? 'mx-0' : 'mx-[10px] md:mx-[20px]'
        } max-w-maxContentWidth rounded-md border-[1px] border-light-gray ${className}`}
      >
        <RelatedProductGroups
          position='home_bottom'
          classes={{
            list: 'grid md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 lg:gap-10 grid-cols-2 gap-[10px]',
          }}
          block_title={i18n._('Frequently bought together')}
          uid={product_uid}
        />
        {/* <div className='my-6 flex w-full items-center justify-center'>
          <PrimaryButton onClick={() => handleClick('/search')}>View All</PrimaryButton>
        </div> */}
      </div>
    </div>
  )
}
